import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//styles
import { Flex } from 'components/styled/Flex';
import { BackText, IconWrapper } from './BackButton.styled';
//assets
import { ArrowRightIcon } from 'assets/icons';
import { useTheme } from 'styled-components';

interface IBackButton {
  to: string;
}

export const BackButton = ({ to }: IBackButton) => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <Flex width="100%" alignItems="center" margin="2rem 0 0 0">
      <Link to={to}>
        <IconWrapper>
          <ArrowRightIcon rotate={180} stroke={colors.black_60} />
        </IconWrapper>
      </Link>

      <Link to={to}>
        <BackText>{t('Back')}</BackText>
      </Link>
    </Flex>
  );
};
